import * as Animate from "react-reveal";

const stats = [
  { value: "300+", label: "leading faculty" },
  { value: "120+", label: "learning programmes" },
  { value: "90%", label: "reported course completion rate" },
];

const differentiators = [
  {
    number: "01",
    title: "Dedicated customer success",
    desc:
      "A partner to align learning strategy, implementation and business priorities.",
  },
  {
    number: "02",
    title: "Enterprise-ready learning",
    desc:
      "A structured experience that can scale across teams while keeping progress visible.",
  },
  {
    number: "03",
    title: "Personalised pathways",
    desc:
      "Adapt content, projects and learning paths to employee needs and organisational context.",
  },
];

const WhyUniqueSection = () => {
  return (
    <section className="bg-hire-tint-blue py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <Animate.Fade bottom>
            <div>
              <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                Why Utiva
              </p>
              <h2 className="text-3xl md:text-4xl leading-tight font-poppins font-black mb-6 tracking-[-0.03em] text-primary">
                Built for learning leaders who need relevance, scale and
                visibility.
              </h2>
              <p className="text-gray text-base font-poppins leading-relaxed mb-8 max-w-md">
                Utiva combines experienced faculty, enterprise-ready delivery
                and personalised learning paths with projects connected to
                workplace outcomes.
              </p>

              <div className="grid grid-cols-3 gap-3">
                {stats.map((stat) => (
                  <article
                    key={stat.label}
                    className="bg-white rounded-2xl p-4"
                  >
                    <strong className="block font-poppins text-2xl text-primary font-extrabold">
                      {stat.value}
                    </strong>
                    <span className="text-gray font-poppins text-xs leading-snug block mt-1">
                      {stat.label}
                    </span>
                  </article>
                ))}
              </div>
            </div>
          </Animate.Fade>

          <Animate.Fade bottom>
            <div className="grid gap-0 border-t border-hire-line">
              {differentiators.map((item) => (
                <div
                  key={item.number}
                  className="grid gap-4 py-6 border-b border-hire-line"
                  style={{ gridTemplateColumns: "38px 1fr" }}
                >
                  <span className="text-[#8e5e00] font-poppins text-xs font-extrabold">
                    {item.number}
                  </span>
                  <div>
                    <h3 className="font-poppins font-bold text-lg text-primary mb-1.5">
                      {item.title}
                    </h3>
                    <p className="text-gray font-poppins text-sm leading-relaxed m-0">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </Animate.Fade>
        </div>
      </div>
    </section>
  );
};

export default WhyUniqueSection;
